import React,{useState} from "react";
import { Page as Page1, Overlay, FileContainer } from "./styles";
import { CloseButton } from "../../../../elements/popupview/styles";
import { GetIcon } from "../../../../../icons";
import { useSelector } from "react-redux";
import { Header } from "../../../../elements/list/manage/styles";
import { NoData } from "../../../../elements/list/styles";
import { useTranslation } from "react-i18next";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
const ViewFiles = ({ setMessage, setLoaderBox, customClass, title, page, item, onClose, admin=false, popup=true }) => {
  const closeModal = () => {
    onClose();
  };
  const themeColors = useSelector((state) => state.themeColors);
  const { t } = useTranslation();
  const fileType = page.data.fileType?.toLowerCase() ?? page.data.file?.split('.').pop().toLowerCase();
  const Download = () => {
    return (
      <a href={`${process.env.REACT_APP_CDN}${page.data?.file}`} download>
        <GetIcon icon={"Download"}></GetIcon>
        {t('Download File')}
      </a>
    );
  };

  const [pdfLink] = useState(`${process.env.REACT_APP_CDN}${page.data?.file}`);

  return (
    <Overlay className={`${customClass ?? "medium"} ${popup?"popup":""}`}>
      <Page1 className={`${customClass ?? "medium"} ${popup?"popup":"nopopup"} popup-child`}>
        {popup && <Header>
          <span>{`${page.data?.user?.fullName??t('download')}`}</span>
          <CloseButton theme={themeColors} onClick={closeModal}>
            <GetIcon icon={"Close"} />
          </CloseButton>
        </Header>}
        <FileContainer>
          {page.data?.adminOnly === true || admin ? (
            fileType ? (
              fileType === "png" || fileType === "jpeg" || fileType === "ppg" ? (
                <>
                  <img src={`${process.env.REACT_APP_CDN}${page.data?.file}`} alt="download" />
                  {Download()}
                </>
              ) : fileType === "pdf" ? (
                <>
                  {/* <div style={{ height: "500px" }}>
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist/build/pdf.worker.min.js`}>
                      <Viewer fileUrl={pdfLink} />
                    </Worker>
                  </div> */}
                  <NoData>{t("previewNotAvailable")}</NoData>
                  {Download()}
                </>
              ) : (
                <>{Download()}</>
              )
            ) : (
              <NoData>{t("noFile")}</NoData>
            )
          ) : (
            <NoData>
              <GetIcon icon={"lock"}></GetIcon>
              {t("noAccess")}
            </NoData>
          )}
        </FileContainer>
      </Page1>
    </Overlay>
  );
};

export default ViewFiles;
